import React from "react";
import CheckBox from "./form-controls/CheckBox";
import PropTypes from "prop-types";
import { useSaveFiltersFlag } from "../hooks/useSaveFiltersFlag";
import {
  isFeatureHighlighted,
  getFeatureHighlightLabel,
  getFeatureHighlightStyle,
} from "../helpers/FeatureHighlight";

const SaveFiltersToggle = ({
  localized = {},
  className = "",
  setUserFlags,
}) => {
  const {
    isSaveFiltersEnabled,
    toggleSaveFilters,
    isAddingFlag,
    isRemovingFlag,
  } = useSaveFiltersFlag(setUserFlags);

  const handleToggle = async () => {
    if (isAddingFlag || isRemovingFlag) {
      return;
    }

    try {
      await toggleSaveFilters();
    } catch (error) {
      console.error("Failed to toggle Save Filters:", error);
    }
  };

  const isLoading = isAddingFlag || isRemovingFlag;
  const shouldHighlight = isFeatureHighlighted("saveFilters");
  const highlightLabel = localized?.New || getFeatureHighlightLabel("saveFilters");
  const highlightStyle = getFeatureHighlightStyle();

  return (
    <div
      style={{ display: "flex", alignItems: "center" }}
      aria-busy={isLoading}
    >
      {shouldHighlight && <span style={highlightStyle}>{highlightLabel}</span>}

      <CheckBox
        className={`save-filters-toggle ${className || ""}`}
        onClick={handleToggle}
        label={localized?.EnableSaveFilters || "Save Search Filters"}
        checked={isSaveFiltersEnabled}
        disabled={isLoading}
      />
    </div>
  );
};

SaveFiltersToggle.propTypes = {
  localized: PropTypes.shape({
    EnableSaveFilters: PropTypes.string,
    New: PropTypes.string,
  }),
  className: PropTypes.string,
  setUserFlags: PropTypes.func.isRequired,
};

export default SaveFiltersToggle;
